'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgAiSpark, SvgBookmarkFill, SvgGovFill } from '@common/icon';
import { cn } from '@core/utils';
import type { MouseEvent } from 'react';
import { BOOKMARK_TYPE } from '@/api';
import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { ROUTES } from '@/constants';
import { useBookmark } from '@/hooks/useBookmark';
import { useSubscribedState } from '@/hooks/useSubscribedState';
export interface PolicyData {
  id: string;
  slugId?: string;
  contentId?: number;
  title: string;
  aiSummary: string;
  applicationPeriod: string;
  agencyName: string;
  agencyLogo: string;
  isBookmarked: boolean;
}
interface SearchPolicyCardProps {
  policy: PolicyData;
  showBookmark?: boolean;
}
export function SearchPolicyCard(t0) {
  const $ = _c(41);
  const {
    policy,
    showBookmark: t1
  } = t0;
  const showBookmark = t1 === undefined ? true : t1;
  const {
    bookmark
  } = useBookmark();
  const [isBookmarked, setIsBookmarked] = useSubscribedState(policy.isBookmarked);
  let t2;
  if ($[0] !== bookmark || $[1] !== isBookmarked || $[2] !== policy.agencyName || $[3] !== policy.contentId || $[4] !== policy.id || $[5] !== policy.title || $[6] !== setIsBookmarked) {
    t2 = e => {
      e.stopPropagation();
      e.preventDefault();
      if (!policy.contentId) {
        return;
      }
      const wasBookmarked = isBookmarked;
      setIsBookmarked(!wasBookmarked);
      bookmark({
        contentId: policy.contentId,
        isBookmarked: wasBookmarked,
        bookmarkType: BOOKMARK_TYPE.POLICY,
        idx: policy.id,
        contentName: policy.title,
        policyAgency: policy.agencyName
      });
    };
    $[0] = bookmark;
    $[1] = isBookmarked;
    $[2] = policy.agencyName;
    $[3] = policy.contentId;
    $[4] = policy.id;
    $[5] = policy.title;
    $[6] = setIsBookmarked;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleBookmarkClick = t2;
  let t3;
  if ($[8] !== policy.id || $[9] !== policy.slugId) {
    t3 = ROUTES.POLICY_DETAIL.pathname({
      idIdx: policy.slugId ?? policy.id
    });
    $[8] = policy.id;
    $[9] = policy.slugId;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== policy.title) {
    t4 = <h3 className="line-clamp-2 flex-1 overflow-hidden font-600 text-Gray-black typo-body3 mobile-tablet:line-clamp-none mobile-tablet:truncate">{policy.title}</h3>;
    $[11] = policy.title;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== handleBookmarkClick || $[14] !== isBookmarked || $[15] !== showBookmark) {
    t5 = showBookmark && <button type="button" aria-label={isBookmarked ? "\uBD81\uB9C8\uD06C \uD574\uC81C" : "\uBD81\uB9C8\uD06C"} className="group size-24 shrink-0 flex-center mobile-tablet:hidden" onClick={handleBookmarkClick}><SvgBookmarkFill className={cn("size-16 text-Gray-400 transition-colors duration-150", {
        "text-B-500": isBookmarked,
        "group-hover:text-Gray-600": !isBookmarked
      })} /></button>;
    $[13] = handleBookmarkClick;
    $[14] = isBookmarked;
    $[15] = showBookmark;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t4 || $[18] !== t5) {
    t6 = <div className="flex h-48 items-start justify-between mobile-tablet:h-auto">{t4}{t5}</div>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="mr-4 inline-flex items-center gap-2 align-middle"><SvgAiSpark className="size-12" /><span className="whitespace-nowrap bg-gradient-to-r from-B-400 to-P-550 bg-clip-text font-700 text-transparent">AI 요약</span></span>;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== policy.aiSummary) {
    t8 = <div className="text-clip rounded-small bg-Gray-25 p-12"><p className="line-clamp-2 text-Gray-600 typo-caption1">{t7}{policy.aiSummary}</p></div>;
    $[21] = policy.aiSummary;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== policy.applicationPeriod) {
    t9 = <span className="shrink-0 text-Gray-900 typo-caption1">신청기간 : {policy.applicationPeriod}</span>;
    $[23] = policy.applicationPeriod;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== policy.agencyLogo || $[26] !== policy.agencyName) {
    t10 = <div className="size-20 overflow-hidden rounded-pill border border-Gray-300 bg-Gray-white flex-center">{policy.agencyLogo ? <Image src={policy.agencyLogo} alt={policy.agencyName} width={20} height={20} className="size-full object-contain" /> : <SvgGovFill className="size-12 text-Gray-400" />}</div>;
    $[25] = policy.agencyLogo;
    $[26] = policy.agencyName;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== policy.agencyName) {
    t11 = <span className="truncate font-600 text-Gray-500 typo-caption1">{policy.agencyName}</span>;
    $[28] = policy.agencyName;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t10 || $[31] !== t11) {
    t12 = <div className="ml-auto flex min-w-0 shrink items-center gap-4">{t10}{t11}</div>;
    $[30] = t10;
    $[31] = t11;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t12 || $[34] !== t9) {
    t13 = <div className="flex flex-wrap items-center gap-x-12 gap-y-4">{t9}{t12}</div>;
    $[33] = t12;
    $[34] = t9;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== t13 || $[37] !== t3 || $[38] !== t6 || $[39] !== t8) {
    t14 = <CustomLink href={t3} className="flex cursor-pointer flex-col gap-8 overflow-hidden rounded-medium border border-Gray-100 bg-Gray-white px-24 py-20 transition-colors hover:bg-Gray-25 mobile-tablet:rounded-none mobile-tablet:border-x-0 mobile-tablet:border-b-0 mobile-tablet:border-t mobile-tablet:first:border-t-0">{t6}{t8}{t13}</CustomLink>;
    $[36] = t13;
    $[37] = t3;
    $[38] = t6;
    $[39] = t8;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  return t14;
}